/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Completed from './Completed/index'
import Created from './Created/index'
import Failed from './Failed/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/AlignItero/Content/Content/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let iteroScanStatusValueData = fromData.useDataValue({ viewPath,
context: 'itero_scan',
path: 'status',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: iteroScanStatusValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Completed'}>
<Completed
  viewPath={`${viewPath}/Completed`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Created'}>
<Created
  viewPath={`${viewPath}/Created`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Failed'}>
<Failed
  viewPath={`${viewPath}/Failed`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}